export { default } from './OfferAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferAdd/index.js